// link
import React from "react";
import { Link, NavLink } from "react-router-dom";

const MenuItems = (props: any) => {
    const isActive = props.item.items?.some(
        (child: any) => child.address === props.currentPath
    );
    return (
        <>
            <div key={props.item.address} className="admin-menu-item position-relative mb-3">
                <div className="admin-menu-item-content-text pb-0">
                    <Link to={props.item.address} className={props.currentPath === props.item.address || isActive ? 'active' : ''}>
                        <div
                            className={'d-flex align-items-center admin-menu-item-text px-3 py-2 pb-2'}
                            data-bs-toggle="collapse"
                            data-bs-target={`#item-collapse${props.index}`}>
                            <div className="mt-1 d-flex align-items-center">
                                {props.item.icon}
                                <p className={'mb-0 ms-1'}>{props.item.label}</p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div
                    className={props.currentPath === props.item.address || isActive ? 'item-collapse collapse show' : 'item-collapse collapse'}
                    id={`item-collapse${props.index}`}>
                    <div className="py-2">
                        <ul className="list-group text-end rounded-0">
                            {props.item.items?.map((child: any) => (
                                <li key={child.address} hidden={!child.show}
                                    className="list-group-item px-4 border-0">
                                    <NavLink to={child.address}>
                                        {child.label}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MenuItems